<template>
  <div>
    <Title :title="'订单趋势'" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :width="style.width" :height="style.height"/>
  </div>
</template>

<script>
import Chart from '../chart.vue';
import Title from '../../title';
import { siteLeft } from '@/api/singleSite/left';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      cdata: {
        category: [],
        rateData: [],
        id:"userAddChart",
        legendData:[],
        series:[
          {
            name: "",
            type: "line",
            smooth: true,
            // showAllSymbol: true,
            // symbol: "emptyCircle",
            symbolSize: 1,
            // yAxisIndex: 1,
            areaStyle: {
              color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color:"rgba(54,161,255,0.6)" },
                  { offset: 1, color: "rgba(25,104,255,0)"}
              ]),
              opacity: 0.5
            },
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(61,230,255,1)" },
                  { offset: 1, color: "rgba(25,104,255,1)" }
              ])
            },
            data: []
          }
        ]
      },
      style:{
        width: '433',
        height: '200'
      }
    };
  },
  components: {
    Chart,
    Title,
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectStationOrderCurrent(data)
    },
    selectStationOrderCurrent(data={}){
      let _this = this;
      let params = {
				"enCode":"TiDB-zhandian-dingdanqushitu",//TiDB-站点-订单趋势图
        "@station_id":data.stationId
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let power_exchange_order_num = [];
          let xList = [];
          res.forEach(item=>{
            power_exchange_order_num.push(item.power_exchange_order_num);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = power_exchange_order_num;//商用
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>